export interface Advisor {
  name: string
  title: string
  titleEs: string
  subtitle: string
  initials: string
  gradient: string
  borderColor: string
  accentColor: string
  bio: string
  photo?: string
  link?: string
  linkedin?: string
  confirmed?: boolean
}

export const advisors: Advisor[] = [
  {
    name: 'Shin Fujiyama',
    title: 'Founder',
    titleEs: 'Rol',
    subtitle: '1,000 Schools Honduras',
    initials: 'SF',
    gradient: 'from-haa-midblue to-haa-blue',
    borderColor: 'border-haa-midblue',
    accentColor: 'text-haa-midblue',
    bio: "Shin Fujiyama is a Japanese-American philanthropist and the co-founder/executive director of Students Helping Honduras, a nonprofit focused on expanding access to education. After first volunteering in Honduras as a college student, he committed his life to building schools and supporting communities across the country through the One Thousand Schools vision. Known for turning endurance challenges into fundraising campaigns, he has completed long-distance runs to raise money for new school construction and reconstruction. Through his on-the-ground work and storytelling, he's become one of the most recognizable advocates for Honduran children's education.",
    photo:
      'https://cdn.magicpatterns.com/uploads/dVdJ4tiMDPrAvo4SeymQqc/Shin_Pic.png',
    link: 'https://onethousandschools.com/about-us/',
    linkedin: 'https://www.linkedin.com/in/shinfujiyama/',
    confirmed: true,
  },
  {
    name: 'Eva Callejas',
    title: 'President & CEO Emeritus',
    titleEs: 'Rol',
    subtitle: 'Honduras Global',
    initials: 'EC',
    gradient: 'from-haa-skyblue to-haa-midblue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: 'Eva Callejas is a Honduran civic leader who previously served as the Executive Director (and a leading figure) of Honduras Global, a diaspora knowledge network focused on connecting Honduran talent abroad with development initiatives at home. In that role, she helped build partnerships with government and education stakeholders to advance innovation, technology, and opportunity for Honduran communities. Through her work with Honduras Global, she has been a visible voice elevating Honduran success stories internationally and channeling expertise back to Honduras.',
    photo:
      'https://cdn.magicpatterns.com/uploads/w99BmRAVRdGsXGQqgnMPrp/Eva_Pic.png',
    linkedin:
      'https://www.linkedin.com/in/eva-callejas-sierra-m-sc-m-b-a-1b761450/',
    confirmed: true,
  },
  {
    name: 'Diana Brown',
    title: 'School Board Member',
    titleEs: 'Rol',
    subtitle: 'Manassas City Public Schools',
    initials: 'DB',
    gradient: 'from-haa-skyblue to-haa-midblue',
    borderColor: 'border-haa-skyblue',
    accentColor: 'text-haa-skyblue',
    bio: "Diana Brown serves on the Manassas City School Board, where she is a visible advocate for strong public schools, inclusive learning environments, and student-centered decision-making. She was elected in 2025 to a four-year term, and she is also the Vice-Chair of Northern Virginia Community College's College Board. An immigrant from Honduras and an award-winning educator, Brown brings deep experience in special education leadership and has been recognized statewide for her work supporting students and teachers.",
    photo:
      'https://cdn.magicpatterns.com/uploads/8WtmbUze1LwXtbXxojZsjD/Diana_Pic.png',
    link: 'https://www.nvcc.edu/about/leadership/college-board/members/brown.html',
    linkedin: 'https://www.linkedin.com/in/diana-brown-291107a8/',
    confirmed: true,
  },
  {
    name: 'Jose Quiroz',
    title: 'Sheriff',
    titleEs: 'Rol',
    subtitle: "Arlington County Sheriff's Office",
    initials: 'JQ',
    gradient: 'from-haa-navy to-blue-950',
    borderColor: 'border-haa-navy',
    accentColor: 'text-haa-navy',
    bio: "Jose Quiroz serves as Sheriff of Arlington County, Virginia, leading the Sheriff's Office in its responsibilities for jail operations, courthouse security, and community-facing public safety services. He joined the Arlington County Sheriff's Office on September 10, 2001, and rose through the ranks before taking office as Sheriff in January 2023. He is Arlington's first Latino Sheriff, and his parents are immigrants from Honduras, a background he often cites as central to his commitment to service and community trust.",
    photo:
      'https://cdn.magicpatterns.com/uploads/oPQ7qAuAvm777pjMfuJg4i/JQuiroz_BioPic.png',
    link: 'https://www.arlingtonva.us/Government/County-Leadership/Executive-Bios/Jose-Quiroz',
    confirmed: true,
  },
]
